import { useQuery } from "@tanstack/react-query";
import { useUser } from "@context/contexts";
import { useApi } from "@hooks/useApi";

/**
 * Hook to fetch and manage subscription status
 * Polls every 30 seconds when subscription is active
 */
export const useSubscription = ({ enabled = true } = {}) => {
    const { token } = useUser();
    const api = useApi();

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["subscription-status", token],
        queryFn: async () => {
            return api.get("subscription-status");
        },
        enabled: Boolean(token) && enabled,
        refetchInterval: 30000, // Poll every 30 seconds
        staleTime: 10000, // Consider stale after 10 seconds
    });

    return {
        subscription: data,
        isLoading,
        error,
        refetch,
        isActive: data?.status === "active",
    };
};
